/* eslint-disable @typescript-eslint/no-explicit-any */
export const isActionActive = (auction: any) => {
  const now = new Date().getTime();
  const auctionEndDate = new Date(auction.end_time).getTime();
  const diff = auctionEndDate - now;

  return diff > 0;
};
